export default __webpack_public_path__ + "static/media/stanford.19527393.jpg";